module.exports = __webpack_public_path__ + "img/logo-argecam.5e5cc4bf.png";